export const IMAGES = {
  heroTexture: "https://images.pexels.com/photos/7605679/pexels-photo-7605679.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  approachAnalyze: "https://images.unsplash.com/photo-1572021335469-31706a17aaef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  approachPlan: "https://images.unsplash.com/photo-1585399058947-f68f9db58e5f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  approachBuild: "https://images.unsplash.com/photo-1596496181871-9681eacf9764?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  jobgrid: "https://images.unsplash.com/photo-1690378820474-b468b8ee64d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  scrollstory: "https://images.unsplash.com/photo-1504691342899-4d92b50853e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  slackr: "https://images.unsplash.com/photo-1758873269276-9518d0cb4a0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  talenhub: "https://images.unsplash.com/photo-1529932398402-e0b30f66a559?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  approachAdopt: "https://images.unsplash.com/photo-1576267423048-15c0040fec78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  logo: "/chepl-mark.png?v=2",
  logoFull: "/chepl-logo.png?v=2",
};

export const translations = {
  nl: {
    nav: { work: "Werk", services: "Diensten", approach: "Aanpak", contact: "Contact", cta: "Start een project" },
    hero: {
      brandline: "CHECK-IN WITH PEOPLE",
      brandsub: "Software voor mensen — gebouwd om processen te verbeteren.",
      lines: ["Software die", "processen", "simpel maakt."],
      intro: "CHEPL bouwt slimme softwareplatformen — van apps tot volledige full-stack integraties, doordrenkt met AI. Wij zetten mensen centraal en maken processen meetbaar efficiënter.",
      cta: "Neem contact op",
      ctaSecondary: "Bekijk ons werk",
      floatCard: "Gemiddeld −60% handwerk",
      floatCardSub: "na proces-analyse",
    },
    marquee: ["MENSGERICHT", "APPS", "FULL-STACK", "AI-COMPONENTEN", "SAAS", "MAATWERK", "INTEGRATIES", "AUTOMATISERING"],
    stats: {
      items: [
        { value: "4+", label: "Platformen live" },
        { value: "AI-first", label: "In elk product" },
        { value: "1 team", label: "Van analyse tot livegang" },
        { value: "100%", label: "Gebouwd rond jouw proces" },
      ],
    },
    services: {
      overline: "Wat wij bouwen",
      title: "Van idee tot werkend platform.",
      subtitle: "Wij bouwen SaaS-oplossingen én maatwerkplatformen voor individuele klanten. Sky is the limit — vertel ons het probleem, wij denken in oplossingen.",
      items: [
        { tag: "01", title: "Apps & Web Platformen", desc: "Snelle, schaalbare applicaties die aanvoelen als maatwerk. Van MVP tot volwaardig product, gebouwd om te groeien met jouw organisatie." },
        { tag: "02", title: "Full-stack Integraties", desc: "Wij verbinden jouw systemen, data en tools tot één soepel geheel — geen losse eilandjes, maar één efficiënte workflow." },
        { tag: "03", title: "AI-componenten", desc: "Intelligente automatisering, agents en modellen die werk uit handen nemen en betere beslissingen mogelijk maken." },
        { tag: "04", title: "SaaS & Maatwerk", desc: "Kant-en-klare SaaS of volledig op maat — wat het beste past bij jouw doel, budget en ambitie." },
      ],
    },
    tech: {
      overline: "Onze gereedschapskist",
      title: "Wij bouwen met de juiste tools.",
      subtitle: "Geen tech om de tech. We kiezen per vraagstuk de stack die het beste past — modern, bewezen en toekomstbestendig.",
      groups: [
        { name: "Frontend", items: ["React", "Next.js", "Tailwind", "TypeScript"] },
        { name: "Backend", items: ["Node.js", "Python", "FastAPI", "GraphQL"] },
        { name: "AI & Data", items: ["LLM's", "RAG", "AI-agents", "MongoDB"] },
        { name: "Cloud & DevOps", items: ["AWS", "Docker", "CI/CD", "Kubernetes"] },
      ],
    },
    approach: {
      overline: "Onze aanpak",
      title: "Wij kijken eerst wat écht nodig is.",
      subtitle: "Geen software om de software. We analyseren je processen en bouwen vanuit daar een verbeterplan dat écht impact maakt.",
      steps: [
        { num: "01", title: "Analyseren", desc: "We duiken in je processen en achterhalen wat daadwerkelijk nodig is. Waar zit de wrijving, waar valt tijd te winnen, wat kan slimmer?" },
        { num: "02", title: "Verbeterplan", desc: "Op basis van de analyse ontwikkelen we een concreet verbeterplan. Duidelijke prioriteiten, meetbare doelen, realistische stappen." },
        { num: "03", title: "Bouwen", desc: "We bouwen de oplossing — app, platform of AI-integratie — en blijven bijsturen tot het écht werkt in jouw dagelijkse praktijk." },
        { num: "04", title: "Adoptie", desc: "We zorgen dat de software zó intuïtief is dat je team er meteen mee werkt — met een maatwerk-adoptieplan. Want geen enkel bedrijf is hetzelfde." },
      ],
    },
    calc: {
      overline: "Reken het uit",
      title: "Wat levert slimme software jou op?",
      subtitle: "Beweeg de schuifjes en zie in realtime hoeveel tijd en geld je bespaart door repetitief werk te automatiseren.",
      team: "Teamgrootte",
      hours: "Uren handwerk p.p. / week",
      cost: "Uurtarief (€)",
      resHours: "uur bespaard per jaar",
      resMoney: "bespaard per jaar",
      note: "Indicatieve berekening: ~60% automatiseerbaar handwerk over 46 werkweken.",
      cta: "Bespreek jouw besparing",
    },
    portfolio: {
      overline: "Geselecteerd werk",
      title: "Platformen die we hebben gebouwd.",
      subtitle: "Een greep uit onze projecten. Elk gebouwd rond een concreet proces en een duidelijke efficiëntieslag.",
      projects: [
        { name: "Jobgrid", cat: "Recruitment platform", desc: "Een slim recruitmentplatform dat vacatures, kandidaten en teams samenbrengt. Matching, workflow en overzicht in één, zodat aannemen sneller en scherper gaat." },
        { name: "ScrollStory", cat: "Content & storytelling", desc: "Interactieve scrollytelling-tool waarmee organisaties verhalen en data tot leven brengen. Boeiende content publiceren zonder een developer nodig te hebben." },
        { name: "Slackr", cat: "Team & communicatie", desc: "Een communicatie- en samenwerkplatform dat teams verbindt. Gesprekken, taken en context op één plek, met minder ruis en meer flow." },
        { name: "TalentHub", cat: "Sport & talentontwikkeling", desc: "Een platform voor het volgen en ontwikkelen van je spelers — van amateur tot Eredivisie en ongeacht de sport. Prestaties, groei en begeleiding overzichtelijk op één plek." },
      ],
    },
    contact: {
      overline: "Laten we bouwen",
      title: "Klaar om je proces te verbeteren?",
      subtitle: "Vertel ons waar je tegenaan loopt. Wij analyseren, denken mee en komen met een verbeterplan — vrijblijvend.",
      name: "Naam",
      email: "E-mail",
      company: "Bedrijf (optioneel)",
      message: "Waar kunnen we mee helpen?",
      submit: "Verstuur bericht",
      sending: "Versturen…",
      success: "Bedankt! We nemen snel contact met je op.",
      error: "Er ging iets mis. Probeer het opnieuw of mail ons direct.",
      directTitle: "Liever direct?",
    },
    footer: {
      built: "Software voor mensen, gebouwd rond jouw proces.",
      rights: "Alle rechten voorbehouden.",
      privacy: "Privacyverklaring",
    },
  },
  en: {
    nav: { work: "Work", services: "Services", approach: "Approach", contact: "Contact", cta: "Start a project" },
    hero: {
      brandline: "CHECK-IN WITH PEOPLE",
      brandsub: "Software for people — built to improve processes.",
      lines: ["Software that", "makes processes", "simple."],
      intro: "CHEPL builds smart software platforms — from apps to full-stack integrations, powered by AI. We put people first and make processes measurably more efficient.",
      cta: "Get in touch",
      ctaSecondary: "See our work",
      floatCard: "On average −60% manual work",
      floatCardSub: "after process analysis",
    },
    marquee: ["HUMAN-FIRST", "APPS", "FULL-STACK", "AI COMPONENTS", "SAAS", "CUSTOM BUILD", "INTEGRATIONS", "AUTOMATION"],
    stats: {
      items: [
        { value: "4+", label: "Platforms live" },
        { value: "AI-first", label: "In every product" },
        { value: "1 team", label: "From analysis to launch" },
        { value: "100%", label: "Built around your process" },
      ],
    },
    services: {
      overline: "What we build",
      title: "From idea to working platform.",
      subtitle: "We build SaaS solutions and custom platforms for individual clients. Sky is the limit — tell us the problem, we think in solutions.",
      items: [
        { tag: "01", title: "Apps & Web Platforms", desc: "Fast, scalable applications that feel bespoke. From MVP to full product, built to grow with your organisation." },
        { tag: "02", title: "Full-stack Integrations", desc: "We connect your systems, data and tools into one smooth whole — no isolated islands, just one efficient workflow." },
        { tag: "03", title: "AI Components", desc: "Intelligent automation, agents and models that take work off your plate and enable better decisions." },
        { tag: "04", title: "SaaS & Custom", desc: "Ready-made SaaS or fully bespoke — whatever fits your goal, budget and ambition best." },
      ],
    },
    tech: {
      overline: "Our toolkit",
      title: "We build with the right tools.",
      subtitle: "No tech for tech's sake. We pick the stack that best fits each challenge — modern, proven and future-proof.",
      groups: [
        { name: "Frontend", items: ["React", "Next.js", "Tailwind", "TypeScript"] },
        { name: "Backend", items: ["Node.js", "Python", "FastAPI", "GraphQL"] },
        { name: "AI & Data", items: ["LLMs", "RAG", "AI agents", "MongoDB"] },
        { name: "Cloud & DevOps", items: ["AWS", "Docker", "CI/CD", "Kubernetes"] },
      ],
    },
    approach: {
      overline: "Our approach",
      title: "We first look at what's truly needed.",
      subtitle: "No software for software's sake. We analyse your processes and build an improvement plan that makes real impact.",
      steps: [
        { num: "01", title: "Analyse", desc: "We dive into your processes and uncover what's actually needed. Where's the friction, where can time be saved, what can be smarter?" },
        { num: "02", title: "Improvement plan", desc: "Based on the analysis we develop a concrete improvement plan. Clear priorities, measurable goals, realistic steps." },
        { num: "03", title: "Build", desc: "We build the solution — app, platform or AI integration — and keep refining until it truly works in your daily practice." },
        { num: "04", title: "Adoption", desc: "We make the software so intuitive your team adopts it right away — with a tailor-made adoption plan. Because no two companies are alike." },
      ],
    },
    calc: {
      overline: "Do the math",
      title: "What does smart software save you?",
      subtitle: "Move the sliders and see in real time how much time and money you save by automating repetitive work.",
      team: "Team size",
      hours: "Manual hours p.p. / week",
      cost: "Hourly rate (€)",
      resHours: "hours saved per year",
      resMoney: "saved per year",
      note: "Indicative estimate: ~60% automatable manual work across 46 working weeks.",
      cta: "Discuss your savings",
    },
    portfolio: {
      overline: "Selected work",
      title: "Platforms we've built.",
      subtitle: "A selection of our projects. Each built around a concrete process and a clear efficiency gain.",
      projects: [
        { name: "Jobgrid", cat: "Recruitment platform", desc: "A smart recruitment platform bringing vacancies, candidates and teams together. Matching, workflow and overview in one, so hiring is faster and sharper." },
        { name: "ScrollStory", cat: "Content & storytelling", desc: "Interactive scrollytelling tool that lets organisations bring stories and data to life. Publish engaging content without needing a developer." },
        { name: "Slackr", cat: "Team & communication", desc: "A communication and collaboration platform that connects teams. Conversations, tasks and context in one place, with less noise and more flow." },
        { name: "TalentHub", cat: "Sports & talent development", desc: "A platform for tracking and developing your players — from amateur to top-flight professional, whatever the sport. Performance, growth and coaching clearly in one place." },
      ],
    },
    contact: {
      overline: "Let's build",
      title: "Ready to improve your process?",
      subtitle: "Tell us what you're struggling with. We analyse, think along and come back with an improvement plan — no strings attached.",
      name: "Name",
      email: "Email",
      company: "Company (optional)",
      message: "What can we help you with?",
      submit: "Send message",
      sending: "Sending…",
      success: "Thanks! We'll be in touch soon.",
      error: "Something went wrong. Please try again or email us directly.",
      directTitle: "Prefer direct?",
    },
    footer: {
      built: "Software for people, built around your process.",
      rights: "All rights reserved.",
      privacy: "Privacy statement",
    },
  },
};

export const COMPANY = {
  name: "CHEPL bv",
  email: "info@chepl.nl",
  phone: "030 207 2501",
  kvk: "KvK 42087917",
  vat: "BTW NL869653817B01",
};
